//js import
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

export function initializeEventListingSliders() {
    const eventListingSliderItems = document.querySelectorAll('.events-listing__item');
    eventListingSliderItems.forEach((slider, index) => {
        let slidersElm = slider.querySelector('.events-listing__slider');
        if (!slidersElm) {
            throw new Error(`Slider element not found at index ${index}`);
        }
        let nextButton = slider.querySelector('.events-listing__slider-next');
        if (!nextButton) {
            throw new Error(`Next button element not found at index ${index}`);
        }
        let prevButton = slider.querySelector('.events-listing__slider-prev');
        if (!prevButton) {
            throw new Error(`Previous button element not found at index ${index}`);
        }
        let paginationElement = slider.querySelector('.events-listing__slider-pagination');
        if (!paginationElement) {
            throw new Error(`Pagination element not found at index ${index}`);
        }
        /**
         * Create a new Swiper instance for the current slider.
         * The options are as follows:
         *   - speed: 1000, the speed of the transition between slides.
         *   - spaceBetween: 16, the space between the slides.
         *   - slidesPerView: 1, the number of slides that are visible at the same time.
         *   - centeredSlides: true, whether the slides should be centered or not.
         *   - loop: false, whether the slider should loop or not.
         *   - freeMode: true, whether the slider should be in free mode or not.
         *   - navigation: an object with the next and prev buttons.
         *   - pagination: an object with the pagination element.
         */
        let eventSlider = new Swiper(slidersElm, {
            speed: 1000,
            spaceBetween: 16,
            slidesPerView: 1,
            centeredSlides: true,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            pagination: {
                el: paginationElement,
                clickable: true,
            },
            breakpoints: {
                576: {
                    centeredSlides: false,
                    slidesPerView: 1,
                    
                },
            },
            
        });
    });
}